/**
 *
 * Middleware that gets initial data from servers and dispatches events (ie to add them to a store, etc)
 * Used to get event types from the server
 *
 */
import { ConnectedRouter } from '@jauntin/react-ui';
import EventTypeService from '../Helpers/EventTypeService';
import API from '../Helpers/API';
import { eventTypeCustomizations } from '../Constants/eventTypes';
import { setEventTypes, errorResponse } from '../Actions/actions';
// Storage.setItemLifetime('eventTypes', Storage.minutes(30));

const addCustomizationsToEventTypes = (original, customizations) => {
  const updated = [...original];
  customizations.forEach((customization) => {
    const index = updated.findIndex(
      (subject) => subject.identifier === customization.identifier,
    );
    updated[index] = { ...updated[index], ...customization };
  });
  return updated;
};

const InitializeDataMiddleware = (store) => (next) => (action) => {
  if (
    action.type === ConnectedRouter.LOCATION_CHANGE &&
    store.getState().formPage.eventTypes.length === 0
  ) {
    return new EventTypeService(new API()).getEventTypes().then(
      (response) => {
        const data = addCustomizationsToEventTypes(
          response.data,
          eventTypeCustomizations,
        );
        store.dispatch(setEventTypes(data));
        return next(action);
      },
      (err) => {
        store.dispatch(errorResponse(err));
      },
    );
  }
  return next(action);
};

export default InitializeDataMiddleware;
